import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class FeedbackApi {
    constructor(private axios: AxiosInstance) {
    }

    collectMessageIndexes = async (): Promise<Array<MessageIndexType>> => {
        const {data}: { data: Array<MessageIndexType> } = await this.axios
            .withAuthentication()
            .get('/v1/feedback/collect-message-indexes');

        return data;
    };

    collectMessageContents = async (
        ids: Array<string>
    ): Promise<Array<MessageContentType>> => {
        const {data}: { data: Array<MessageContentType> } = await this.axios
            .withAuthentication()
            .get('/v1/feedback/collect-message-contents', {
                params: {
                    ids: ids,
                },
            });

        return data;
    };

    countUnreadSysMessageIndexes = async (from: number): Promise<number> => {
        const {data}: { data: number } = await this.axios
            .withAuthentication()
            .get('/v1/feedback/count-unread-sys-message-indexes', {
                params: {
                    from: from,
                },
            });

        return data;
    };

    sendMessage = async (text: string) => {
        const {data} = await this.axios
            .withAuthentication()
            .post('/v1/feedback/send-message', {
                text: text,
            });

        return data;
    };
}

export type MessageIndexType = { user: string; message: string };
export type MessageContentType = { id: string; text: string };

decorate(injectable(), FeedbackApi);
decorate(inject(AxiosInstance), FeedbackApi, 0);

export {FeedbackApi};
